<template>
  <div class="bottom-modal-item" :style="{ width: `${windowWidth}px` }">
    <div class="header" :class="{ 'is-border': border }">
      <div class="header-left">
        <div class="header-left-inner">
          <img
            v-if="$parent.dataShowIndex > 1"
            src="@/assets/icon-back.png"
            @click="$parent.$emit('bottommodal:back')"
          />
          <slot name="leftButton"></slot>
        </div>
      </div>
      <div class="header-center">{{ title }}</div>
      <div class="header-right">
        <img
          src="@/assets/icon-close.png"
          @click="$parent.$emit('close')"
        />
      </div>
    </div>
    <div class="info">
      <slot name="info"></slot>
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    border: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      windowWidth: document.body.offsetWidth
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/px2rem.scss";

.bottom-modal-autoheight {
  .bottom-modal-item {
    height: auto;
    .content {
      position: relative;
      padding-top: 0;
    }
  }
}

.bottom-modal-item {
  position: relative;
  float: left;
  height: 100%;
  background: #fff;
  border-top-left-radius: px2rem(10);
  border-top-right-radius: px2rem(10);

  .header {
    display: flex;
    position: relative;
    z-index: 1;
    height: px2rem(120);
    justify-content: center;
    align-items: center;
    padding: 0 px2rem(30);

    &.is-border {
      border-bottom: 1px solid #eeeeee;
    }

    > div {
      flex: 1;
    }
    .header-right {
      text-align: right;
    }
    .header-left img,
    .header-right img {
      width: px2rem(40);
      height: px2rem(40);
    }
    .header-center {
      text-align: center;
      font-size: px2rem(40);
      flex: auto;
    }
    .header-left-inner {
      display: flex;
      align-items: center;
    }
    .header-left {
      font-size: px2rem(28);
      color: #999;
    }
  }

  .info {
    position: relative;
    top: px2rem(-25);
    text-align: center;
    color: #666;
  }

  .content {
    position: absolute;
    top: 0;
    left: 0;
    height: inherit;
    padding-top: px2rem(120);
    box-sizing: border-box;
    overflow-y: auto;
    width: 100%;
    -webkit-overflow-scrolling: touch;
  }
}
</style>
